module.exports = __webpack_public_path__ + "static/media/compec.ef6ecd63.png";